import NoteModal from './NoteModal';

export default NoteModal;
